/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_EO as EO,
  rec_Er as Er,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SelectorMultiple as SelectorMultiple,
  rec_ei as ei,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function AgendarEnArea(e) {
  let t = (0, ReactCompiler.c)(31),
    { fecha: n, unidades: r, onCerrar: i, onReunion: a, onTarea: o } = e,
    s;
  t[0] !== r[0] || t[1] !== r.length
    ? ((s = () => (r.length === 1 ? String(r[0].id) : ``)),
      (t[0] = r[0]),
      (t[1] = r.length),
      (t[2] = s))
    : (s = t[2]);
  let [c, l] = (0, React.useState)(s),
    u;
  if (t[3] !== c || t[4] !== r) {
    let e;
    (t[6] === c
      ? (e = t[7])
      : ((e = (e) => String(e.id) === c), (t[6] = c), (t[7] = e)),
      (u = r.find(e)),
      (t[3] = c),
      (t[4] = r),
      (t[5] = u));
  } else u = t[5];
  let f = u,
    p;
  t[8] === n
    ? (p = t[9])
    : ((p = n.split(`-`).reverse().join(`/`)), (t[8] = n), (t[9] = p));
  let m = `Agendar para el ${p}`,
    h;
  t[10] !== c || t[11] !== r
    ? ((h = r.length > 1 && (
        <label
          className={`text-xs text-(--text)`}
          children={[
            `Área`,
            <SelectorMultiple
              value={c}
              onChange={(e) => l(e || ``)}
              placeholder={`Elegí el área`}
              opciones={r.map(EO)}
            />,
          ]}
        />
      )),
      (t[10] = c),
      (t[11] = r),
      (t[12] = h))
    : (h = t[12]);
  let _;
  t[13] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((_ = <Er className={`mr-1.5 inline h-4 w-4`} />), (t[13] = _))
    : (_ = t[13]);
  let v;
  t[14] === a
    ? (v = t[15])
    : ((v = (
        <button
          type={`button`}
          onClick={a}
          className={`${zo} justify-center py-3`}
          children={[_, ` Una reunión`]}
        />
      )),
      (t[14] = a),
      (t[15] = v));
  let y = !f,
    b;
  t[16] !== f || t[17] !== o
    ? ((b = () => o(f)), (t[16] = f), (t[17] = o), (t[18] = b))
    : (b = t[18]);
  let x;
  t[19] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((x = (0, JSXRuntime.jsx)(ei, {
        className: `mr-1.5 inline h-4 w-4`,
      })),
      (t[19] = x))
    : (x = t[19]);
  let S;
  t[20] !== y || t[21] !== b
    ? ((S = (
        <button
          type={`button`}
          disabled={y}
          onClick={b}
          className={`${zo} justify-center py-3 disabled:cursor-not-allowed disabled:opacity-50`}
          children={[x, ` Una tarea para esa fecha`]}
        />
      )),
      (t[20] = y),
      (t[21] = b),
      (t[22] = S))
    : (S = t[22]);
  let C;
  t[23] !== S || t[24] !== h || t[25] !== v
    ? ((C = <div className={`flex flex-col gap-3`} children={[h, v, S]} />),
      (t[23] = S),
      (t[24] = h),
      (t[25] = v),
      (t[26] = C))
    : (C = t[26]);
  let w;
  return (
    t[27] !== i || t[28] !== C || t[29] !== m
      ? ((w = <Modal titulo={m} onClose={i} ancho={`max-w-sm`} children={C} />),
        (t[27] = i),
        (t[28] = C),
        (t[29] = m),
        (t[30] = w))
      : (w = t[30]),
    w
  );
}
